import React from 'react';
import './dataInfo.scss'

const DataInfo = ({title='', datas, divider=true}) => {
    return (
    <div className='data-info-wrap'>
        {title !== '' && <h2 className='title'>{title}</h2>}
        <ul>
            {datas.map(data =>
                <li key={data.key}>
                    <p className={`${data.style?.fontWeight? 'bold':''}`}>{data.key}</p>
                    <p className='value' style={data.style}>
                        {Array.isArray(data.value) ? data.value.map(val => <span>{val}</span>) : <span>{data.value}</span>}
                    </p>
                </li>
            )}

        </ul>
        {divider && <div className='divider-line' style={{backgroundColor:'#eaeaea'}}/>}
    </div>
    );
};

export default DataInfo;